export const OrganizationalRoleType = {
    Unknown: 0,
    AppUser: 1,
    Manager: 2,
    PortalAdmin: 3,
    Custom: 100,
};